import { FC } from 'react';
import css from './settings-pages.module.css';

type T = {

}

export const SettingsPageSupport:FC<T> = () => {
    return(
        <>
        <h1 className={css.settingsHeader}>О проекте</h1>
        <div className={css.settingsData}>
            <h1>MigdOS - симулятор операционной системы. Это интерактивное приложение, созданное на React.js.</h1>
            <h2>Основные функции:</h2>
            <h3>Простой интерфейс</h3>
            <p>Легкий в использовании дизайн, который напоминает настоящую операционную систему.</p>
            <h3>Множество окон</h3>
            <p>Открывайте несколько окон для работы с разными задачами и файлами одновременно.</p>
            <h3>Настройки</h3>
            <p>Настраивайте внешний вид приложения под свои предпочтения.</p>
        </div>
        </>
    );
}